import React, { useEffect, useState } from 'react';
import { Modal } from 'antd';
import { Button } from 'components';
import { useDispatch, useSelector } from 'react-redux';
import { supplierUpdateVoucher, getVoucher } from 'store/forms/actions';
import { UploadTemp } from 'components';
import { ReactComponent as CheckVerify } from 'assets/icons/checkVerify.svg';


const RedeemModal = (
  { docs, 
    error, 
    openReedemModal, 
    setOpenReedemModal,
    openRedeemOverwriteModal,
    setOpenRedeemOverwriteModal, 
    openVerificatioModal,
    setOpenVerificatioModal,
    attachments, 
    setAttachments}) => {
  const dispatch = useDispatch();
  const legalVat = useSelector(state => state.forms.carrier.legalVat);
  const voucherInfo = useSelector(state => state.forms?.supplier?.voucherInfo);
    
  //----------------------------  DOCS VALIDATION -------------------------------\\
    // Get required file codes
    const requiredDocs = docs().filter(doc => doc.required);

    // Check if all required docs have at least one uploaded file
    const allRequiredUploaded = requiredDocs.every(doc => 
      attachments?.some(file => file.type === doc.fileCode)
    );

    // Check if at least one required doc has an uploaded file
    const atLeastOneRequiredUploaded =  docs().some(doc =>
      attachments?.some(file => file.type === doc.fileCode)
    );

  //----------------------------  REDEEM ACTION -------------------------------\\
  const handleRedeem = () => {
    const parameters = {
        voucherCode: voucherInfo?.voucher?.code || '',
        vatId: legalVat,
      }

    const filteredAttachments = (attachments || []).map(({ size, ...rest }) => rest);

    const payload = {
            voucherCode: voucherInfo?.voucher?.code || '', 
            vatId: legalVat,
            ean: voucherInfo?.voucher?.ean || '',
            action: openReedemModal ? 'REDEEM' : 'REDEEM_OVERWRITE',
            attachments: filteredAttachments || [],
          };
    dispatch(supplierUpdateVoucher({simulation: false, params: payload, parameters}));
    setAttachments([]);
  };

  const handleVerification = () => {
    setOpenVerificatioModal(true);
  }

  useEffect(()=>{
    if(!openReedemModal || !openRedeemOverwriteModal) {
      setAttachments([]);}
  },[openReedemModal, openRedeemOverwriteModal])

return (
    <>
        <Modal
          centered
          width={680}
          open={(openReedemModal || openRedeemOverwriteModal) && !openVerificatioModal}
          onCancel={() => openReedemModal ? setOpenReedemModal(false) : setOpenRedeemOverwriteModal(false)}
          onOk={() => openReedemModal ? setOpenReedemModal(false) : setOpenRedeemOverwriteModal(false)}
          closable={true}
          footer={null}
          maskClosable={false}
        >
          <CheckVerify/>
          <h2 className={'font-size-18'} style={{ marginTop: 10}}>
            {openReedemModal ? 'Αίτημα Πληρωμής' : 'Διόρθωση Αρχείων Αιτήματος Πληρωμής'}
          </h2>
          {error && 
              <div className='mt-2 mb-2 color-red' style={{textAlign: 'center' }}>
                <p>{error.responseDescription}</p>
              </div>
            }
            <div>
            {docs().map((item, index) => (
              <UploadTemp 
                key={index}
                item={item}
                openRedeemOverwriteModal={openRedeemOverwriteModal}
                uploadedFiles={attachments?.filter(f => f.type === item.fileCode)}
                setUploadedFiles={(newFilesOfThisType) => {
                  setAttachments(prev => {
                    // Remove old files of same type and append new ones
                    const filtered = prev.filter(f => f.type !== item.fileCode);
                    return [...filtered, ...newFilesOfThisType];
                  });
                }}
              />
            ))}
          </div>
            <div className='modal-buttons-container'>
               <Button
                type="default"
                className={"ant-btn-primary return-btn"}
                label={'Ακύρωση'}
                onClick={() => openReedemModal ? setOpenReedemModal(false) : setOpenRedeemOverwriteModal(false)}
              />
              <Button
                type="default"
                className={"ant-btn-primary verify-btn"}
                label={'Επιβεβαίωση'}
                disabled={!(allRequiredUploaded && openReedemModal) && !(openRedeemOverwriteModal && atLeastOneRequiredUploaded)}
                onClick={() => handleVerification()}
              />
            </div>
          </Modal>
          
          {/* VERIFICATION MODAL */}
          <Modal
          centered
          width={400}
          open={openVerificatioModal}
          onCancel={() => setOpenVerificatioModal(false)}
          onOk={() => setOpenVerificatioModal(false)}
          closable={true}
          footer={null}
          maskClosable={false}
        >
          <CheckVerify/>
          <h2 className={'font-size-18'} style={{ marginTop: 10}}>
            {openReedemModal ? 'Αίτημα Πληρωμής' : 'Διόρθωση Αρχείων Αιτήματος Πληρωμής'}
          </h2>
            {error && 
              <div className='mt-2 mb-2 color-red' style={{textAlign: 'center' }}>
                <p>{error.responseDescription}</p>
              </div>
            }
            <div>
            <p>
            {openReedemModal ? 
              'Είστε βέβαιος/-η οτι επιθυμέίτε να προχωρήσετε σε αίτημα πληρωμής για το παρών voucher;' : 
              'Είστε βέβαιος/-η οτι επιθυμέίτε να αντικαταστείτε το/τα αρχείο/-α του αιτήματος πληρωμής για το παρών voucher;'}
            </p>
          </div>
            <div className='modal-buttons-container'>
               <Button
                type="default"
                className={"ant-btn-primary return-btn"}
                label={'Ακύρωση'}
                onClick={() => setOpenVerificatioModal(false)}
              />
              <Button
                type="default"
                className={"ant-btn-primary verify-btn"}
                label={'Επιβεβαίωση'}
                disabled={!(allRequiredUploaded && openReedemModal) && !(openRedeemOverwriteModal && atLeastOneRequiredUploaded)}
                onClick={handleRedeem}
              />
            </div>
          </Modal>
    </>
  );
};

export default RedeemModal;